import { injectable, inject } from "inversify";
import AbstractConnect from "../../../../framework/src/connect/ajax/AbstractConnect";
import { parseURL } from "../../../../framework/src/connect/Connect";
import IConnectControl from "../../../../framework/src/connect/controllers/IConnectControl";
import FetchAjax from "../../../../framework/src/connect/FetchAjax";
import SERVICE_IDENTIFIER from "../../../../framework/src/constants/identifiers";
import SystemConfig, {
	CONFIG_PARAMS,
} from "../../../../framework/src/system/SystemConfig";
import IDOM from "../../../../framework/src/ui/IDOM";
interface IlevelInfoWinData {
	credit_value: number;
	display_value: number;
	currency: string;
}

interface ILevelInfoData {
	level_name: string;
	level: number;
	win_counter: number;
	last: IlevelInfoWinData;
	highest: IlevelInfoWinData;
}
@injectable()
export class LevelInfo extends AbstractConnect {
	fetchType: string = "JokerWinConnect";
	groupId: number;
	level: string;

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
		@inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
		@inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
	) {
		super(config, control, fetch, dom);
		this.timeout = 3000;
		this.setMethod("GET"); // TODO take from settings, currently receiving wrong value from wegas (POST)
	}
	async fetch(): Promise<ILevelInfoData[]> {
		this.control.reset();

		return (await this._fetch()).data;
	}
	protected getParams(): Record<string, any> {
		return {};
	}
	protected getUrl(): string {
		return parseURL(this.config.get(CONFIG_PARAMS.URL_JOKER_BONUS_LEVEL_INFO), {
			currency: this.config.get(CONFIG_PARAMS.CURRENCY),
			group_id: this.groupId,
			level_name: this.level,
		});
	}
}
